<template>

  <div :data-item-id="item.id" class="search-item clearfix">
    <div class="item-content">
      <div class="list-item-norm-date">{{ item.created }}</div>
      <div class="list-item-norm-title">
          <span class="list-item-norm-doc-type" v-html="doc_type"></span>
          <span class="list-item-norm-doc-number" v-html="doc_number"></span>
          <span class="list-item-norm-doc-date-valid" v-html="doc_date"></span>
      </div>
      <div class="list-item-norm-link">
        <a :href="item_href" class="search-item-link" v-html="item_title"></a>
      </div>
      <div class="list-item-producer">
        {{ item.doc_producer }}
        <div v-if="item.doc_producer && item.doc_producer_full && item.doc_producer != item.doc_producer_full && item.doc_producer_full.length" class="producer-tip">{{ item.doc_producer_full }}</div>
      </div>
      <div class="norm-status" :class="status_class">{{ item.document_status_label}}
        {{ item.date_invalid && item.date_invalid.length && item.document_status == 'invalid' ? '(' + item.date_invalid + ')' : '' }}
        {{ item.date_partially_invalid && item.date_partially_invalid.length && item.document_status == 'partially_invalid' ? '(' + item.date_partially_invalid + ')' : '' }}
      </div>
    </div>
  </div>

</template>

<script>

  export default {

    props: {
      item: Object,
    },



    methods: {

      tag_trancate (tag) {
        return s.truncate(tag, 18);
      },

    },

    computed: {

      item_href () {
        return '/norm/' + this.item.id;
      },

      status_class () {
        return 'status-' + this.item.document_status;
      },

      item_title () {
        return this.$parent.highlight(this.item.title);
      },

      doc_type () {
        return this.$parent.highlight(this.item.doc_type);
      },

      doc_number () {
        return this.item.document_number && this.item.document_number.length ? ( this.$parent.highlight('№') + ' ' + this.$parent.highlight(this.item.document_number) ) : '';
      },

      doc_date () {
        return this.item.date_init ? ( ' ' + this.$parent.highlight(this.$parent.text.from) + ' ' + this.$parent.highlight(this.item.date_init)) : '';
      },

    }

  }

</script>
